import Link from 'next/link'
import { Grid, Typography, List, ListItem, Button } from '@mui/material'

// Types
import type { FooterColumnProps } from '@/types/components/molecules/footer/column'

const FooterColumnMolecule = (props: FooterColumnProps) => {
	// Props
	const { title, items } = props

	return (
		<Grid container>
			<Grid size={12}>
				<Typography component="h3" pl={1} fontSize={{ xs: 12, md: 14 }} fontWeight={700} textTransform="uppercase">
					{title}
				</Typography>
			</Grid>

			<Grid size={12} mt={1}>
				<List sx={{ py: 0 }}>
					{items.map((item, index) => {
						return (
							<ListItem
								key={index}
								color="text.secondary"
								sx={{
									p: 0,
									'& a': { width: 1 }
								}}
							>
								<Link href={item.link_value} target="_blank">
									<Button
										variant="text"
										sx={{
											width: 1,
											textAlign: 'inherit',
											color: 'common.white'
										}}
									>
										<Typography component="span" width={1} fontSize={{ xs: 12, md: 14 }} fontWeight={700}>
											{item.title}
										</Typography>
									</Button>
								</Link>
							</ListItem>
						)
					})}
				</List>
			</Grid>
		</Grid>
	)
}

export default FooterColumnMolecule
